// eslint-disable-next-line
const debug = require("debug")("cs.delay");

async function delay(milliseconds: number): Promise<void> {
  await new Promise((resolve) => {
    debug(`Delaying for ${milliseconds}ms`);
    setTimeout(() => {
      resolve(true);
    }, milliseconds);
  });
}

export default delay;
